// extracted by mini-css-extract-plugin
export default {"wrapper":"IsbnsForm_wrapper__gceCG","form":"IsbnsForm_form__RSOQH"};